import { render, staticRenderFns } from "./UsuariosEditar.vue?vue&type=template&id=295628d5&scoped=true&"
import script from "./UsuariosEditar.vue?vue&type=script&lang=js&"
export * from "./UsuariosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295628d5",
  null
  
)

export default component.exports